import { render, staticRenderFns } from "./fczs_detail.vue?vue&type=template&id=1ed57365&"
import script from "./fczs_detail.vue?vue&type=script&lang=js&"
export * from "./fczs_detail.vue?vue&type=script&lang=js&"
import style0 from "./fczs_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports